import { LinkFieldsFragment } from "src/__generated__/client.codegen";

export const getDataFromRecord = (record: Partial<LinkFieldsFragment>) => {
	if (
		record.__typename === "PageRecord" ||
		record.__typename === "InsuranceProductFamilyRecord"
	) {
		return {
			name: record.name ?? "",
			href: `${record.slug}`,
		};
	}

	if (record.__typename === "ProductPageRecord" && record.productFamily) {
		if (record.productCategory) {
			return {
				name: record.name ?? "",
				href: `${record.productCategory.productFamily.slug}/${record.productCategory.slug}/${record.slug}`,
			};
		}

		return {
			name: record.name ?? "",
			href: `${record.productFamily.slug}/${record.slug}`,
		};
	}

	if (record.__typename === "ProductCategoryRecord" && record.productFamily) {
		return {
			name: record.name ?? "",
			href: `${record.productFamily.slug}/${record.slug}`,
		};
	}

	return { name: "", href: "" };
};

// 🔬 TBD
